import { render, staticRenderFns } from "./POIDescription.vue?vue&type=template&id=60b24dd4"
import script from "./POIDescription.js?vue&type=script&lang=js&external"
export * from "./POIDescription.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports